var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2850_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 8.0996,
    r: 7.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06892 11.2727C8.90536 11.288 8.74114 11.2511 8.59983 11.1673C8.49658 11.0613 8.44708 10.9141 8.4653 10.7673C8.46911 10.645 8.4837 10.5233 8.50892 10.4036C8.53333 10.2663 8.56486 10.1304 8.60345 9.99635L9.03255 8.51997C9.0768 8.37425 9.10605 8.22438 9.11983 8.07269C9.11983 7.90906 9.14164 7.79632 9.14164 7.73088C9.15077 7.43922 9.02623 7.15935 8.80345 6.97088C8.52942 6.7605 8.18817 6.6571 7.84345 6.67997C7.59642 6.68369 7.3513 6.72413 7.11617 6.79997C6.8592 6.87997 6.58889 6.97572 6.30527 7.08725L6.18164 7.56725C6.26527 7.53816 6.36711 7.50544 6.48345 7.46907C6.59445 7.43619 6.70952 7.41903 6.82527 7.41816C6.98764 7.40057 7.15108 7.44044 7.28708 7.53088C7.37945 7.6411 7.4228 7.78428 7.40708 7.92725C7.40667 8.04953 7.39327 8.17144 7.36708 8.29088C7.34161 8.41816 7.30889 8.55269 7.26889 8.6945L6.83617 10.1781C6.8013 10.316 6.77339 10.4556 6.75255 10.5963C6.73555 10.7168 6.72705 10.8383 6.72708 10.9599C6.7253 11.2536 6.85958 11.5315 7.0907 11.7127C7.36895 11.9263 7.71508 12.0322 8.06523 12.0108C8.3118 12.0159 8.55752 11.9803 8.79252 11.9054C8.99858 11.8351 9.27373 11.7345 9.61798 11.6036L9.73436 11.1454C9.64111 11.1841 9.54508 11.2157 9.44708 11.2399C9.32314 11.2682 9.19589 11.2792 9.06892 11.2727Z",
    fill: "#365D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5237 4.27272C9.32579 4.09097 9.06504 3.99319 8.79642 4C8.52795 3.99394 8.26745 4.09162 8.06913 4.27272C7.70563 4.58615 7.66504 5.13494 7.97851 5.49847C8.00645 5.53087 8.03673 5.56115 8.06913 5.58909C8.48326 5.9595 9.10957 5.9595 9.52367 5.58909C9.88717 5.27256 9.92526 4.72131 9.60873 4.35781C9.58242 4.32753 9.55398 4.29909 9.5237 4.27272Z",
    fill: "#365D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00039 0.199994C3.69257 0.199994 0.200391 3.69217 0.200391 7.99999C0.200391 12.3078 3.69257 15.8 8.00039 15.8C12.3082 15.8 15.8004 12.3078 15.8004 7.99999C15.8004 3.69217 12.3082 0.199994 8.00039 0.199994ZM8.00039 14.7091C4.29505 14.7091 1.29131 11.7053 1.29131 7.99999C1.29131 4.29466 4.29505 1.29091 8.00039 1.29091C11.7057 1.29091 14.7095 4.29466 14.7095 7.99999C14.7095 11.7053 11.7057 14.7091 8.00039 14.7091Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2850_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFill);
export default __webpack_public_path__ + "static/media/info-fill.aba447171db5355e11ce32492ce7c4a7.svg";
export { ForwardRef as ReactComponent };